export default "__VITE_ASSET__BG650tuX__"